module.exports = "/img/story-2.23f68732.png";